export const uploadConfig = {
  api: `${process.env.REACT_APP_API_URL}/upload`,
};

export type ImageType =
  | 'vehicle-image'
  | 'service-event-image'
  | 'service-event-attachment'
  | 'business-image'
  | 'fault-image'
  | 'partner-image'
  | 'vehicle-attachment';
